export const UPDATE_FREQUENCY_TIME = 'UPDATE_FREQUENCY_TIME'

export const LAST_BAR_UPDATED_ON = 'LAST_BAR_UPDATED_ON'

